import * as Yup from 'yup';

const requiredPeriodNumber = (label, min, max, rangeMessage) =>
	Yup.number()
		.transform((value, originalValue) =>
			originalValue === '' || originalValue === null ? undefined : value
		)
		.required(`${label} es obligatorio`)
		.min(min, rangeMessage)
		.max(max, rangeMessage);

export const generatePaymentSchema = Yup.object({
	month: requiredPeriodNumber(
		'El mes',
		1,
		12,
		'El mes debe estar entre 1 y 12'
	),
	year: requiredPeriodNumber(
		'El año',
		2020,
		2030,
		'El año debe estar entre 2020 y 2030'
	),
	includeSma: Yup.boolean(),
});

export const formatAmericaSantiagoPeriodHint = (now = new Date()) =>
	new Intl.DateTimeFormat('es-CL', {
		timeZone: 'America/Santiago',
		year: 'numeric',
		month: 'long',
	}).format(now);
